import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1b07644&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e1b07644&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b07644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b07644')) {
      api.createRecord('e1b07644', component.options)
    } else {
      api.reload('e1b07644', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e1b07644&scoped=true", function () {
      api.rerender('e1b07644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/alliance/code/index.vue"
export default component.exports